// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const IPaddressIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="IPaddressIcon" ref={forwardedRef} {...props}>
      <path d="M14.75 10.5A3.24 3.24 0 0 1 18 13.734c0 1.778-3.183 5.232-3.215 5.266 0 0-3.285-3.48-3.285-5.266a3.24 3.24 0 0 1 3.25-3.234m0 1.727a1.45 1.45 0 0 0-1.462 1.439 1.45 1.45 0 0 0 1.462 1.44 1.45 1.45 0 0 0 1.462-1.44 1.45 1.45 0 0 0-1.462-1.44" />
      <path d="M10 2a8 8 0 0 1 8 8q-.002.142-.008.282a4.8 4.8 0 0 0-1.372-.898 7 7 0 0 0-.056-.46h-3q.009.111.014.222a4.7 4.7 0 0 0-1.323.562 11 11 0 0 0-.047-.783H7.792a11.4 11.4 0 0 0 .139 3.15h2.376a4.7 4.7 0 0 0-.294 1.35H8.268a11.2 11.2 0 0 0 1.628 3.223L10 16.65l.104-.002a11 11 0 0 0 .53-.801 17 17 0 0 0 1.178 1.944A8 8 0 1 1 10 2M4.299 13.425a6.67 6.67 0 0 0 3.806 2.95 12.6 12.6 0 0 1-1.246-2.95zm-.862-4.5a6.7 6.7 0 0 0 .245 3.15H6.56a12.7 12.7 0 0 1-.123-3.15zm4.671-5.302a6.67 6.67 0 0 0-4.3 3.952h2.816a12.7 12.7 0 0 1 1.484-3.952m1.788-.271a11.3 11.3 0 0 0-1.892 4.223h3.992a11.3 11.3 0 0 0-1.894-4.223L10 3.35zm1.995.271a12.7 12.7 0 0 1 1.485 3.952h2.816a6.67 6.67 0 0 0-4.301-3.952" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const IPaddressIcon = /* @__PURE__ */ Object.assign(
  IPaddressIconComponent,
  { displayName: 'IPaddressIcon' },
);
